<template>
  <div style="width:fit-content;">
      <b-dropdown size="sm">
        <template slot="button-content"> <i class="icon-settings"></i></template>
        <b-dropdown-item @click="cambioPass()"><i class="fa fa-lock" /> Cambiar contraseña</b-dropdown-item>
        <b-dropdown-item @click="cerrarSesion()"><i class="fa fa-power-off" /> Cerrar sesión</b-dropdown-item>
      </b-dropdown>
   </div>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import swal from 'sweetalert'
import { mapGetters } from "vuex";

export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  computed: {
    ...mapGetters([
      "httpURL",
      "sessionToken"
    ])
  },
  data: () => {
    return { itemsCount: 42 }
  },
  methods: {
    cerrarSesion(){
        localStorage.removeItem('token');
        sessionStorage.removeItem('token');
        this.$store.dispatch("setSessionToken", null);
        this.$router.push('/login');
    },
    cambioPass(){
        this.$router.push('/usuarios/cambio-pass');
    }
  }
}
</script>
